import { API_BASE_URL } from './config';

let getAccessToken = () => null;
let refreshAccessToken = async () => null;
let onAuthLost = () => {};
let refreshInFlight = null;

/**
 * Configure the API client. Call from AuthProvider after mount.
 * @param {{ getToken: () => string | null, refreshFn: () => Promise<string | null>, onLogout: () => void }}
 */
export function configureApiClient({ getToken, refreshFn, onLogout }) {
  getAccessToken = getToken ?? (() => null);
  refreshAccessToken = refreshFn ?? (async () => null);
  onAuthLost = onLogout ?? (() => {});
}

/**
 * Authenticated fetch - adds Bearer token, retries on 401 after refresh
 * @param {string} path - API path (e.g. /api/v1/...)
 * @param {RequestInit} options - fetch options
 * @returns {Promise<Response>}
 */
export async function apiFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE_URL}${path}`;

  const doFetch = (authToken) => {
    const headers = new Headers(options.headers);
    if (authToken) {
      headers.set('Authorization', `Bearer ${authToken}`);
    }
    return fetch(url, { ...options, headers });
  };

  let res = await doFetch(getAccessToken());

  if (res.status === 401) {
    if (!refreshInFlight) {
      refreshInFlight = refreshAccessToken().finally(() => {
        refreshInFlight = null;
      });
    }
    const newToken = await refreshInFlight;
    if (newToken) {
      res = await doFetch(newToken);
    } else {
      onAuthLost();
      throw new Error('Session expired. Please log in again.');
    }
  }

  return res;
}
